export const GET_TRANSFER_TAB = 'GET_TRANSFER_TAB';
export const GET_NARRATIVE_TAB = 'GET_NARRATIVE_TAB';
